import { render, staticRenderFns } from "./welfareOperation.vue?vue&type=template&id=47161878&scoped=true&"
import script from "./welfareOperation.vue?vue&type=script&lang=js&"
export * from "./welfareOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47161878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47161878')) {
      api.createRecord('47161878', component.options)
    } else {
      api.reload('47161878', component.options)
    }
    module.hot.accept("./welfareOperation.vue?vue&type=template&id=47161878&scoped=true&", function () {
      api.rerender('47161878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/welfareOperation/welfareOperation.vue"
export default component.exports